import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { SpinnerService } from '../../spinner/spinner.service';
import { BundlesService } from 'src/app/pages/bundles/bundles.service';

@Component({
    selector: 'app-bundles-modal',
    templateUrl: './bundles-modal.component.html',
    styleUrls: ['./bundles-modal.component.scss'],
})
export class BundlesModalComponent {
    @Input() data: any;
    modalData: any = [];
    header: any;
    @Input() showSpinner: boolean = true;
    bundlesSubscription$?: Subscription;

    dataFetched: boolean = false;

    constructor(private bundlesService: BundlesService, private spinner: SpinnerService) {}

    ngOnInit() {
        this.bundlesSubscription$ = this.bundlesService.bundles$.subscribe((params: any) => {
            if (params) {
                switch (params.type) {
                    case 'BUNDLES_CONTENT_DATA_GET_SUCCESSFUL':
                        console.log('INSIDE BUNDLE MODAL', params.data);
                        setTimeout(() => {
                            this.showSpinner = false;
                        }, 500);
                        const bundlesContentData = params.data;
                        this.header = bundlesContentData;
                        this.modalData = bundlesContentData.items.map((item: any) => {
                            return {
                                image: item.image ? item.image : '',
                                albumArt: item.albumArt ? item.albumArt : '',
                                bannerArt: item.bannerArt ? item.bannerArt : '',
                                squareArt: item.squareArt ? item.squareArt : '',
                                name: item.name,
                                source: item.source,
                                contentType: item.contentType,
                                woiId: item.woiId,
                            };
                        });
                        this.dataFetched = true;
                        console.log(this.modalData);
                        break;
                }
            }
        });

        this.bundlesService.getBundlesContentData(this.data.id);
    }

    ngOnDestroy() {
        this.bundlesSubscription$?.unsubscribe();
    }
}
